import { inject } from "mobx-react";
import * as React from "react";
import { RouteStore } from "bernie-core";
import { UitkCard, UitkCardContent, UitkCardTextSegment } from "uitk-react-cards";
import { UitkLink, UitkLinkTypeSize } from "uitk-react-link";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { UitkHeading } from "uitk-react-text";
import { useLocalization } from "@shared-ui/localization-context";
import { isVariantEnabled, Experiment } from "src/components/utility/experiment";

const authUrlGenerator = (url: string) => (routeStore?: RouteStore): string => {
  const pathname = routeStore?.pathname || "";
  const queries = routeStore?.search || "";

  const currentUrl = pathname + queries;

  return url + currentUrl;
};

interface LoyaltySignupProps {
  context?: ExtendedContextStore;
  routeStore?: RouteStore;
  classNames?: string;
  variant?: number;
}

export const LoyaltySignup: React.FC<LoyaltySignupProps> = inject(
  "context",
  "routeStore"
)((props: LoyaltySignupProps) => {
  const { classNames = "", context, variant, routeStore } = props;
  const isAuth = context && context.user && context.user.state !== "anonymous";
  const isVariantActive =
    context && isVariantEnabled(context, Experiment.Flex_HTG_Blossom_Loyalty_signin_signup, variant);

  const { formatText } = useLocalization();

  const loyaltySignupTitle = formatText("loyatlySignup.title");
  const loyaltySignupSubtitle = formatText("loyatlySignup.subtitle");
  const linkConfig = [
    {
      message: formatText("loyatlySignup.signUp"),
      trackedLinkRffr: "signUp",
      createGetUrl: authUrlGenerator("/user/createaccount?uurl=e3id=redr%26rurl%3D%2F"),
    },
    {
      message: formatText("loyatlySignup.singIn"),
      trackedLinkRffr: "signIn",
      createGetUrl: authUrlGenerator("/user/signin?uurl=e3id=redr%26rurl%3D%2F"),
    },
  ];

  if (isAuth || !isVariantActive) {
    return null;
  }

  return (
    <div className="uitk-grid" id="loyaltySignup">
      <UitkCard className={classNames}>
        <UitkCardContent>
          <UitkCardTextSegment>
            <ul className="uitk-type-list-300 icon-m">
              <li className="all-b-padding-four">
                <UitkIcon name="mod" className="modIconPosition" size={UitkIconSize.MEDIUM} />
                <UitkHeading level={3} size={300}>
                  {loyaltySignupTitle}
                </UitkHeading>
                <div className="uitk-type-heading-300 uitk-type-regular">{loyaltySignupSubtitle}</div>
                {linkConfig.map(({ createGetUrl, ...linkProps }) => {
                  return <AuthLink key={linkProps.trackedLinkRffr} href={createGetUrl(routeStore)} {...linkProps} />;
                })}
              </li>
            </ul>
          </UitkCardTextSegment>
        </UitkCardContent>
      </UitkCard>
    </div>
  );
});

interface AuthLinkProps {
  message: string;
  trackedLinkRffr: string;
  href: string;
}

const AuthLink: React.FC<AuthLinkProps> = (props) => {
  const { trackedLinkRffr, message, href } = props;

  return (
    <UitkLink inline={true} className="all-r-margin-six" type={UitkLinkTypeSize.SMALL}>
      <TrackedLink
        href={href}
        moduleName="Hotels"
        linkName={trackedLinkRffr}
        rfrr={`loyaltySignup.actionLink.${trackedLinkRffr}`}
      >
        {message}
      </TrackedLink>
    </UitkLink>
  );
};

export default LoyaltySignup;
